type Track = HTMLElement;

function getSlides(track: Track) {
  return Array.from(
    track.querySelectorAll<HTMLElement>(':scope .carousel-item')
  );
}

function scrollToIndex(track: Track, index: number) {
  const w = track.clientWidth;
  track.scrollTo({ left: index * w, behavior: 'smooth' });
}

function initCarousel(root: HTMLElement) {
  const useInterval = root.getAttribute('data-interval') === 'true';
  const intervalSeconds = root.getAttribute('data-interval-length') || '3';
  const autoplayMs = useInterval ? Number(intervalSeconds) * 1000 : null;

  const textTrack = root.querySelector<Track>('[data-carousel-track="text"]');
  const imgTrack = root.querySelector<Track>('[data-carousel-track="images"]');
  const prevBtn = root.querySelector<HTMLButtonElement>('[data-carousel-prev]');
  const nextBtn = root.querySelector<HTMLButtonElement>('[data-carousel-next]');

  if (!textTrack || !imgTrack) return;

  const slideCount = Math.max(
    getSlides(textTrack).length,
    getSlides(imgTrack).length
  );
  if (!slideCount) return;

  let index = 0;
  let autoplayId: number | undefined;
  let resumeTimeoutId: number | undefined;

  function goTo(i: number) {
    index = (i + slideCount) % slideCount;
    scrollToIndex(textTrack!, index);
    scrollToIndex(imgTrack!, index);
  }

  function next() {
    goTo(index + 1);
    pauseThenResume();
  }
  function prev() {
    goTo(index - 1);
    pauseThenResume();
  }

  function pauseThenResume() {
    if (!autoplayMs) return;
    // Stop current autoplay and schedule a restart after the same interval
    stopAutoplay();
    if (resumeTimeoutId) {
      clearTimeout(resumeTimeoutId);
      resumeTimeoutId = undefined;
    }
    resumeTimeoutId = window.setTimeout(() => {
      startAutoplay();
    }, autoplayMs);
  }

  prevBtn?.addEventListener('click', prev);
  nextBtn?.addEventListener('click', next);

  window.addEventListener('resize', () => goTo(index));

  function startAutoplay() {
    if (!autoplayMs) return;
    stopAutoplay();
    autoplayId = window.setInterval(() => {
      const nextIndex = (index + 1) % slideCount;
      goTo(nextIndex);
    }, autoplayMs);
  }

  function stopAutoplay() {
    if (autoplayId) {
      clearInterval(autoplayId);
      autoplayId = undefined;
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopAutoplay();
    else startAutoplay();
  });

  goTo(0);
  startAutoplay();
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll<HTMLElement>('[data-carousel-root]')
    .forEach(initCarousel);
});
